var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dp-dropdown__anchor"},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.close),expression:"close"}],ref:"dropdown",class:[
      'dp-dropdown',
      ("dp-dropdown--arrow-" + _vm.styleArrowPosition),
      {
        'dp-dropdown--visible': _vm.internalVisible,
        'dp-dropdown--above': _vm.isAbove,
        'dp-dropdown--left-aligned': _vm.leftAligned,
      } ]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }